import { render, staticRenderFns } from "./UpdatePersonalAvatar.vue?vue&type=template&id=79c5da59&scoped=true"
import script from "./UpdatePersonalAvatar.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalAvatar.vue?vue&type=script&lang=js"
import style0 from "./UpdatePersonalAvatar.vue?vue&type=style&index=0&id=79c5da59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c5da59",
  null
  
)

export default component.exports